import { collectionEngineV1 } from '../apis.js';
const api = collectionEngineV1('/interaction-categories');
export const getAll = () => api('GET', `/`);
export const create = (category) => api('POST', `/`, {
    body: category,
});
export const update = (id, category) => api('PATCH', `/${id}`, {
    body: category,
});
export const applyToInteraction = (interactionId, interactionCategoryId) => api('POST', `/${interactionCategoryId}/apply-to/${interactionId}`);
export const removeFromInteraction = (interactionId, interactionCategoryId) => api('DELETE', `/${interactionCategoryId}/applied-to/${interactionId}`);
//# sourceMappingURL=interaction-categories.js.map